import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { KeycloakProvider } from '@europrocurement/l2d-keycloak';

import L2DApiProvider from '@europrocurement/l2d-domain/providers/L2DApiProvider/L2DApiProvider';
import { DossierCustomHeaderProvider, SearchBarProvider } from '@europrocurement/l2d-modules';
import { APIS_ENUM, getApiConfiguration } from '@europrocurement/l2d-domain';
import { ParcoursFormalitreHeaderProvider } from '@europrocurement/l2d-modules/modules/ParcoursFormalite/provider';
import { CRMCustomHeaderProvider } from './pages/CRM';

import App from './App';

import { keycloak, updateToken } from './keycloak';
import ReduxProvider from './ReduxProvider';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const apiConfiguration = {
    offre: getApiConfiguration(APIS_ENUM.OFFRE, updateToken),
    formalite: getApiConfiguration(APIS_ENUM.FORMALITE, updateToken),
    tiers: getApiConfiguration(APIS_ENUM.TIERS, updateToken),
    sign: getApiConfiguration(APIS_ENUM.SIGN, updateToken),
    utilisateur: getApiConfiguration(APIS_ENUM.UTILISATEUR, updateToken),
    formulaire: getApiConfiguration(APIS_ENUM.FORMULAIRE, updateToken),
    facturation: getApiConfiguration(APIS_ENUM.FACTURATION, updateToken),
    achats: getApiConfiguration(APIS_ENUM.ACHATS, updateToken),
    dossiers: getApiConfiguration(APIS_ENUM.DOSSIERS, updateToken),
    annoncesLegales: getApiConfiguration(APIS_ENUM.AL, updateToken),
    siren: getApiConfiguration(APIS_ENUM.SIREN, updateToken),
    geoloc: getApiConfiguration(APIS_ENUM.GEOLOC, updateToken),
    societe: getApiConfiguration(APIS_ENUM.SOCIETE, updateToken),
    mail: getApiConfiguration(APIS_ENUM.MAIL, updateToken),
    iaServices: getApiConfiguration(APIS_ENUM.IASERVICES, updateToken),
};

root.render(
    <KeycloakProvider
        initOptions={{
            onLoad: 'login-required',
            checkLoginIframe: false,
        }}
        authClient={keycloak}
    >
        <L2DApiProvider apiConfiguration={apiConfiguration}>
            {/* <React.StrictMode> */}
            <ReduxProvider>
                <CRMCustomHeaderProvider>
                    <DossierCustomHeaderProvider>
                        <SearchBarProvider>
                            <ParcoursFormalitreHeaderProvider back>
                                <App />
                            </ParcoursFormalitreHeaderProvider>
                        </SearchBarProvider>
                    </DossierCustomHeaderProvider>
                </CRMCustomHeaderProvider>
            </ReduxProvider>
            {/* </React.StrictMode> */}
        </L2DApiProvider>
    </KeycloakProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
